"use client";

import React from "react";

export function Gallery10_3() {
  return (
    /* bg-wood-cream = tvoje světle žlutá/béžová, font-sans = Inter */
    <section className="bg-wood-cream text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        
        {/* Nadpis sekce - Gelasio */}
        <div className="mb-12 text-center md:mb-18 lg:mb-20">
          <h2 className="text-[32px] font-bold font-serif leading-[1.2] md:text-[48px] lg:text-[56px]">
            Tesařské a truhlářské práce
          </h2>
        </div>

        {/* Masonry layout - přesně 7 fotek (2 vlevo, 3 uprostřed, 2 vpravo) */}
        <div className="gap-4 space-y-4 md:columns-2 lg:columns-3 md:gap-6 md:space-y-6">
          
          {/* FOTO 1 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 16.png" className="w-full object-cover" alt="Detail 1" />
          </div>

          {/* FOTO 2 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 26.png" className="w-full object-cover" alt="Detail 2" />
          </div>

          {/* FOTO 3 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 36.png" className="w-full object-cover" alt="Detail 3" />
          </div>

          {/* FOTO 4 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 46.png" className="w-full object-cover" alt="Detail 4" />
          </div>

          {/* FOTO 5 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 56.png" className="w-full object-cover" alt="Detail 5" />
          </div>

          {/* FOTO 6 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 66.png" className="w-full object-cover" alt="Detail 6" />
          </div>

          {/* FOTO 7 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 76.png" className="w-full object-cover" alt="Detail 7" />
          </div>

        </div>
      </div>
    </section>
  );
}